import { trackPublicEvent } from "@/features/analytics/api";
import {
  CUSTOMER_IO_EVENT,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";
import type { OnboardingUser } from "@/features/onboarding/models";

interface TrackCreatePasswordViewedParams {
  user?: OnboardingUser;
}

export const trackCreatePasswordViewed = ({
  user,
}: TrackCreatePasswordViewedParams) => {
  triggerGoogleTagManagerTracking({
    event: GOOGLE_TAG_MANAGER_EVENT.CREATE_PASSWORD_VIEWED,
  });

  trackPublicEvent({
    event: CUSTOMER_IO_EVENT.CREATE_PASSWORD_VIEWED,
    properties: { source: window.location.href },
    userId: user?.email,
  });
};
